import React from "react";

const isHTMLElement = (value: unknown): value is HTMLElement => value instanceof HTMLElement;
const isFunction = (value: unknown): value is () => void => typeof value === "function";

export const safeStringifyForLog = (value: unknown) => {
  try {
    return JSON.stringify(value, (key, value) => {
      if (isFunction(value)) {
        return `function ${value.name}(){...}`;
      }

      if (isHTMLElement(value)) {
        return `${value.outerHTML}`;
      }

      if (React.isValidElement(value)) {
        return `React.Element()`;
      }

      return value;
    });
  } catch (ex) {
    console.error(ex);
    return null;
  }
};
